import { padWithZero, timeAgo } from '../../shared/utilities.js';
import './TimeDiff.css';

const TimeDiff = ({ previous, current, latest }) => {
  const timeDiffMs = (new Date(current)) - (new Date(previous));
  const [hours, minutes,] = timeAgo(timeDiffMs);
  const text = `${padWithZero(hours)}:${padWithZero(minutes)}`;
  return (
    <p className="diff-time">
      <span className={`diff-time-line ${latest ? 'to-latest' : ''}`}>
        <span className="diff-time-blade end" />
      </span>
      <span className={`diff-time-value ${latest ? 'to-latest' : ''}`}>{text}</span>
    </p>
  );
}

export default TimeDiff;
